<div class="row" style="text-align: center">
    <div *ngIf="errors && errors.length > 0">
        <p><b>Erros encontrados:</b></p>
        <p style="white-space: pre-line;">{{message}}</p>
    </div>
    <div>
        <p><b>Deseja reenviar a fatura para o financeiro?</b></p>
    </div>
    <div class="row pt-3 pb-3">

        <div class="buttons">
            <button class="easymarine danger" type="button" (click)="closeDialog()">
                {{ "CANCEL" | translate }}
            </button>
            &nbsp; &nbsp;
            <button class="easymarine primary" type="button" (click)="updateLancamentoProgramadoByInvoiceId()">
                {{ "SEND" | translate }}
            </button>
        </div>
    </div>
</div>
